const translation: Record<string, string> = {
  "nav.home": "首页",
  "nav.categories": "赛事分类",
  "nav.news": "体育资讯",
  "nav.about": "关于我们",
  "nav.live": "赛事直播",
  "nav.login": "登录",
  "nav.register": "注册",
  "hero.title": "汇聚全球顶级赛事",
  "hero.subtitle": "随时随地畅享体育精彩",
  "hero.cta": "立即体验",
  "hero.secondary": "了解更多",
  "categories.title": "热门赛事分类",
  "categories.subtitle": "覆盖全球主流体育项目，一站在手尽享全部精彩",
  "categories.viewAll": "查看全部",
  "matches.title": "热门赛事",
  "matches.subtitle": "实时追踪全球精彩对决",
  "matches.live": "直播中",
  "matches.upcoming": "即将开始",
  "matches.finished": "已结束",
  "news.title": "最新体育资讯",
  "news.subtitle": "第一时间获取全球体育动态",
  "news.readMore": "阅读全文",
  "news.viewAll": "查看全部资讯",
  "features.title": "为什么选择我们",
  "features.subtitle": "专业、全面、及时的体育服务平台",
  "features.speed": "极速更新",
  "features.speedDesc": "实时同步全球赛事数据，比分瞬息即达",
  "features.coverage": "全面覆盖",
  "features.coverageDesc": "足球、篮球、网球等30+体育项目一网打尽",
  "features.analysis": "专业分析",
  "features.analysisDesc": "资深体育分析师深度解读每场比赛",
  "features.experience": "极致体验",
  "features.experienceDesc": "高清流畅的直播体验，沉浸式观赛享受",
  "stats.title": "平台数据",
  "stats.subtitle": "千万用户信赖的体育平台",
  "stats.users": "累计用户",
  "stats.matches": "覆盖赛事",
  "stats.countries": "覆盖国家",
  "stats.sports": "体育项目",
  "faq.title": "常见问题",
  "faq.subtitle": "快速了解kaiyun体育平台",
  "cta.title": "准备好开启体育之旅了吗？",
  "cta.subtitle": "加入数百万体育爱好者，体验极致的体育赛事服务",
  "cta.button": "立即加入",
  "footer.slogan": "您的全球体育赛事伙伴",
  "footer.services": "服务项目",
  "footer.company": "关于我们",
  "footer.support": "帮助支持",
  "footer.contact": "联系我们",
  "footer.copyright": "© 2024 kaiyun体育 版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.disclaimer": "免责声明",
  "breadcrumb.home": "首页",
};

export default translation;